<template>
	<div class="pl-3 pr-3 pb-3">
		<div class="d-flex align-items-center">
			<div class="d-flex mr-auto">
				<v-radio-group v-model="popupBatchUpdate.price.updateBy" row class="mt-0" @change="getTypeUpdate()">
					<v-radio :label="$t('_BATCH_UPDATE.TITLE')" value="bulkUpdate" color="primary"></v-radio>
					<!-- <v-radio :label="$t('UPDATE_BY_SALE_CHANNEL')" value="ota" color="primary"></v-radio> -->
					<v-radio :label="$t('UPDATE_BY_ROOM_TYPE')" value="roomtype" color="primary"></v-radio>
					<!-- <v-radio :label="$t('UPDATE_BY_SALE_PACKAGE')" value="roomplan" color="primary"></v-radio> -->

				</v-radio-group>
			</div>
			<div class="text-right">
				<v-btn color="primary" @click="confirmUpdatePrice()">
					<template>{{ $t("UPDATE") }}</template>
				</v-btn>
				<!-- <v-btn color="primary" @click="dialogUpdateRate = true" v-if="popupBatchUpdate.price.updateBy == 'roomtype'">
					<template>{{ $t("UPDATE") }}</template>
				</v-btn> -->
			</div>
		</div>
		<div class="text-center" v-if="popupBatchUpdate.isLoading">
			<img src="@/assets/loading-logo-animation.gif" style="width: 75px" />

			<p class="font-weight-bold">{{ $t('THE_SYSTEM_IS_LOADING') }}</p>
		</div>

		<v-row class="mt-0" v-if="!popupBatchUpdate.isLoading">
			<v-col
				v-if="popupBatchUpdate.price.updateBy == 'roomtype' || popupBatchUpdate.price.updateBy == 'bulkUpdate'">
				<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{ $t("ROOM_TYPE")
				}} *</label>
				<v-autocomplete item-text="text" item-value="value" :items="listRoom.filter((x) => x.value != -1)"
					v-model.lazy="popupBatchUpdate.price.selectedRoomType" outlined chips dense multiple
					@change="$event => checkProductUpdate() & changeRoomSelect($event)">
					<template v-slot:prepend-item>
						<p class="mx-3 mt-1"> <a class="text-primary"
								@click="popupBatchUpdate.price.selectedRoomType = listRoom.map(e => e.value); checkProductUpdate()">{{
									$t('SELECT_ALL') }}</a>
							| <a class="text-primary" @click="popupBatchUpdate.price.selectedRoomType = []">{{
								$t('UN_SELECT_ALL') }}</a>
						</p>
					</template>

					<template v-slot:selection="{ item, index }">
						<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
							:input-value="item.selected" close
							@click:close="remove(index, popupBatchUpdate.price.selectedRoomType)" @click="item.select">
							<span>{{ item.text }}</span>
						</v-chip>
						<span v-if="index === 2" class="grey--text caption">(+{{
							popupBatchUpdate.price.selectedRoomType.length - 2 }})</span>
					</template>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col
				v-if="popupBatchUpdate.price.updateBy == 'roomtype' || popupBatchUpdate.price.updateBy == 'bulkUpdate'">
				<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{
					$t("SALE_PACKAGE") }} *</label>
				<v-autocomplete item-text="text" item-value="value" :items="planList" v-model.lazy="planSelect" outlined @change="$event => checkProductUpdate() & changeRoomSelect($event)"
					chips dense multiple>
					<template v-slot:prepend-item>
						<p class="mx-3 mt-1"> <a class="text-primary" @click="planSelect = planList.map(e => e.value); checkProductUpdate()">{{
							$t('SELECT_ALL') }}</a> | <a class="text-primary" @click="planSelect = []">{{
		$t('UN_SELECT_ALL') }}</a>
						</p>
					</template>
					<template v-slot:selection="{ item, index }">
						<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
							:input-value="item.selected" close @click:close="remove(index, planSelect)"
							@click="item.select">
							<span>{{ item.text }}</span>
						</v-chip>
						<span v-if="index === 2" class="grey--text caption">(+{{ planSelect.length - 2 }})</span>
					</template>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col md="6" v-if="popupBatchUpdate.price.updateBy == 'roomplan'">
				<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
					{{ $t("SALE_PACKAGE") }} *
				</label>
				<v-autocomplete item-text="text" item-value="value" :items="popupBatchUpdate.price.priceByRoomPlanList"
					v-model="popupBatchUpdate.price.priceByRoomPlanSelected" outlined chips dense multiple>
					<template v-slot:prepend-item>
						<p class="mx-3 mt-1"> <a class="text-primary"
								@click="popupBatchUpdate.price.priceByRoomPlanSelected = popupBatchUpdate.price.priceByRoomPlanList.map(e => e.value)">{{
									$t('SELECT_ALL') }}</a>
							| <a class="text-primary" @click="popupBatchUpdate.price.priceByRoomPlanSelected = []">{{
								$t('UN_SELECT_ALL') }}</a>
						</p>
					</template>
					<template v-slot:selection="{ item, index }">
						<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
							:input-value="item.selected" close
							@click:close="remove(index, popupBatchUpdate.price.priceByRoomPlanSelected)"
							@click="item.select">
							<span>{{ item.text }}</span>
						</v-chip>
						<span v-if="index === 2" class="grey--text caption">(+{{
							popupBatchUpdate.price.priceByRoomPlanSelected.length - 2 }})</span>
					</template>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col md="6" v-if="popupBatchUpdate.price.updateBy == 'roomplan'">
				<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{ $t("ROOM_TYPE")
				}} *</label>
				<v-autocomplete item-text="text" item-value="value" :items="listRoom.filter((x) => x.value != -1)"
					v-model.lazy="popupBatchUpdate.price.selectedRoomType" outlined chips dense multiple
					@change="$event => changeRoomSelect($event)">
					<template v-slot:prepend-item>
						<p class="mx-3 mt-1"> <a class="text-primary"
								@click="popupBatchUpdate.price.selectedRoomType = listRoom.map(e => e.value)">{{
									$t('SELECT_ALL') }}</a>
							| <a class="text-primary" @click="popupBatchUpdate.price.selectedRoomType = []">{{
								$t('UN_SELECT_ALL') }}</a>
						</p>
					</template>
					<template v-slot:selection="{ item, index }">
						<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
							:input-value="item.selected" close
							@click:close="remove(index, popupBatchUpdate.price.selectedRoomType)" @click="item.select">
							<span>{{ item.text }}</span>
						</v-chip>
						<span v-if="index === 2" class="grey--text caption">(+{{
							popupBatchUpdate.price.selectedRoomType.length - 2 }})</span>
					</template>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col md="6" v-if="popupBatchUpdate.price.updateBy == 'ota'">
				<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
					{{ $t("SALE_CHANNEL") }} *
				</label>
				<v-autocomplete item-text="text" item-value="value" :items="listOTA"
					v-model="popupBatchUpdate.price.priceByOtaSelected" outlined dense
					@change="getRateByOta(popupBatchUpdate.price.priceByOtaSelected)">
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col v-if="popupBatchUpdate.price.updateBy == 'bulkUpdate'">
				<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
					{{ $t("SALE_CHANNEL") }} *
				</label>
				<v-autocomplete item-text="text" item-value="value" :items="listOTA"
					v-model="popupBatchUpdate.price.priceByOtasSelected" outlined dense multiple @change="$event => changeRoomSelect($event)">
					<template v-slot:prepend-item>
						<p class="mx-3 mt-1"> <a class="text-primary"
								@click="popupBatchUpdate.price.priceByOtasSelected = listOTA.map(e => e.value)">{{
									$t('SELECT_ALL') }}</a>
							| <a class="text-primary" @click="popupBatchUpdate.price.priceByOtasSelected = []">{{
								$t('UN_SELECT_ALL') }}</a>
						</p>
					</template>
					<template v-slot:selection="{ item, index }">
						<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
							:input-value="item.selected" close
							@click:close="remove(index, popupBatchUpdate.price.priceByOtasSelected)" @click="item.select">
							<span>{{ item.text }}</span>
						</v-chip>
						<span v-if="index === 2" class="grey--text caption">(+{{
							popupBatchUpdate.price.priceByOtasSelected.length - 2 }})</span>
					</template>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete>
			</v-col>
		</v-row>

		<v-row class="mt-0 config-price" v-if="!popupBatchUpdate.isLoading">
			<template v-if="popupBatchUpdate.price.updateBy == 'roomtype'">
				<template>
					<div class="w-100">
						<div class="d-sticky h-header-table d-flex">
							<div class="mr-auto">
								<div class="small-gutters d-flex">
									<div class="text-center font-weight-bold"
										:style="item.code === 'MON' ? 'width: 142px' : 'width: 94px'"
										v-for="item in popupBatchUpdate.daysOfWeek" :key="item.value">{{ item.value }}</div>
									<div class="text-center font-weight-bold" style="width: 94px">
										<div class="d-flex">
											<div class="mr-1">Master product</div>
											<v-tooltip top>
												<template v-slot:activator="{ on, attrs }">
													<i class="icon-info fs-14" v-bind="attrs" v-on="on"></i>
												</template>
												<span>{{ $t('TOOLTIP_MASTER') }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
							</div>
							<div class="pb-0 pt-0">
								<!-- <div class="small-gutters"> 		
								<div class="d-input-sl text-center font-weight-bold">{{ $t("ADULT")}}</div> 		
								<div class="d-input-sl text-center font-weight-bold">{{ $t("_BOOKING_DETAIL.ROOM.CHILDREN") }}</div> 		
								<div class="d-input-sl text-center font-weight-bold">{{ $t("_BOOKING_DETAIL.ROOM.BABY") }}</div> 		
								<div class="d-input-sl text-center font-weight-bold">{{ $t("GUEST")}}</div> 	
							</div>  -->
							</div>
						</div>
						<template v-if="popupBatchUpdate.price.hasRoomRate.filter((temp) => popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId)).length > 0"
							v-for="(room, roomIndex) in popupBatchUpdate.price.hasRoomRate.filter((temp) => popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId) && temp.roomRates.filter(item => planSelect.includes(item.ratePlansId)).length > 0)">
							<div class="px-3 py-2"
								v-for="(plan, indexPlan) in room.roomRates.filter(item => planSelect.includes(item.ratePlansId))">
								<b-row>
									<v-col md="8" class="py-0">
										<span class="font-weight-bold text-primary">
											{{ room.romTypeNameI18ns.find((x) => x.lang == defaultI18n).name }} - {{
												plan.romPlanNameI18ns.find((x) => x.lang == defaultI18n).name }}
										</span>
										<v-menu :close-on-content-click="false" :nudge-width="200" offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn class="btn-outline-custom pr-0" v-bind="attrs" v-on="on" x-small>
													{{ $tc('CHANNEL', plan.selectedOta.length.toString()) }} <i
														class="icon-drop-down-list fs-14 ml-2"></i>
												</v-btn>
											</template>

											<v-card>
												<v-list>
													<v-list-item class="px-2">
														<b-form-input v-model="plan.textSearch"
															:placeholder="$t('_HOTEL_CHAIN.SEARCH')"></b-form-input>
													</v-list-item>
													<v-list-item class="px-2">
														<p class="mx-3 mt-1 mb-0"> <a class="text-primary"
																@click="plan.selectedOta = plan.ota.map(e => e.ota.id)">{{
																	$t('SELECT_ALL') }}</a>
															| <a class="text-primary" @click="plan.selectedOta = []">{{
																$t('UN_SELECT_ALL') }}</a>
														</p>
													</v-list-item>
												</v-list>
												<v-list>
													<v-list-item
														v-for="(ota, indOta) in plan.ota.filter(item => item.ota.otaI18n.find((x) => x.lang == defaultI18n).name.toString().toLowerCase().includes(plan.textSearch.toLowerCase()))"
														style="min-height: 28px !important" class="px-2">
														<v-checkbox v-model="plan.selectedOta" class="mt-0 pt-0"
															:label="ota.ota.otaI18n.find((x) => x.lang == defaultI18n).name"
															:value="ota.ota.id"></v-checkbox>
													</v-list-item>
												</v-list>
											</v-card>
										</v-menu>
									</v-col>
									<v-col md="4" class="py-0">

									</v-col>
								</b-row>
								<p v-if="`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors" class="protection-rate-error text-danger mb-1">{{updateErrors[`${room.roomTypeId}_${plan.ratePlansId}`]}}</p>
								<div class="d-flex mt-1">
									<div class="py-0 mr-auto">
										<div class="small-gutters d-flex">
											<div class="pb-0 pt-0 d-flex align-items-center">
												<currency-ptd
													:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, plan.dates.find((x) => x.apply == 'MON').value) 
															? 'protection-border-danger' 
															: ''
													].filter(Boolean).join(' ')"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="plan.dates.find((x) => x.apply == 'MON').value" />
												<v-btn color="primary" @click="copyPrice(plan)" class="ml-1"
													:title="$t('COPY')" icon small><i
														class="icon-content_paste_go fs-16"></i></v-btn>
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, plan.dates.find((x) => x.apply == 'TUE').value) 
															? 'protection-border-danger' 
															: ''
													].filter(Boolean).join(' ')"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="plan.dates.find((x) => x.apply == 'TUE').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, plan.dates.find((x) => x.apply == 'WED').value) 
															? 'protection-border-danger' 
															: ''
													].filter(Boolean).join(' ')"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="plan.dates.find((x) => x.apply == 'WED').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, plan.dates.find((x) => x.apply == 'THU').value) 
															? 'protection-border-danger' 
															: ''
													].filter(Boolean).join(' ')"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="plan.dates.find((x) => x.apply == 'THU').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, plan.dates.find((x) => x.apply == 'FRI').value) 
															? 'protection-border-danger' 
															: ''
													].filter(Boolean).join(' ')"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="plan.dates.find((x) => x.apply == 'FRI').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, plan.dates.find((x) => x.apply == 'SAT').value) 
															? 'protection-border-danger' 
															: ''
													].filter(Boolean).join(' ')"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="plan.dates.find((x) => x.apply == 'SAT').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, plan.dates.find((x) => x.apply == 'SUN').value) 
															? 'protection-border-danger' 
															: ''
													].filter(Boolean).join(' ')"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="plan.dates.find((x) => x.apply == 'SUN').value" />
											</div>
											<div class="py-0 pl-5 text-center" style="width: 94px">
												<b-form-radio v-model="radioRoomType"
												name="some-radios" :value="room.roomTypeId + '|' + plan.ratePlansId"></b-form-radio>
											</div>
										</div>
									</div>
									<div class="py-0 d-flex align-items-center" v-if="radioRoomType && radioRoomType !== (room.roomTypeId + '|' + plan.ratePlansId)">
										<div class="text-right">
											<!-- <span class="font-weight-bold" v-if="roomIndex === 0 && indexPlan === 0"> Master
												<v-tooltip top>
													<template v-slot:activator="{ on, attrs }">
														<i class="icon-info fs-16" v-bind="attrs" v-on="on"></i>
													</template>
													<span>{{ $t('TOOLTIP_MASTER') }}</span>
												</v-tooltip>
											</span> -->
											<div class="d-flex align-center justify-content-end d-multiplier">
												<div class="mr-1">
													<span class="font-weight-bold"> Master *</span>
												</div>
												<div>
													<currency-ptd
														:classC="'input-multiplier v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
														:options="multiplierOption"
														v-model.lazy="plan.multiplier"></currency-ptd>
												</div>
												<span class="font-weight-bold pl-1 pr-1"> + </span>
												<div class="mr-1">
													<currency-ptd
														:classC="'input-plus v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="plan.plus"></currency-ptd>
												</div>
												<v-btn color="primary" outlined x-small @click="copyMaster(plan)"
													:title="$t('COPY_BY_FOMULAR')">
													<i class="icon-move_down fs-16"></i>
												</v-btn>
											</div>
										</div>
									</div>
								</div>
							</div>
							<v-divider class="mt-3 mb-0"></v-divider>
						</template>
					</div>
				</template>
				<template v-if="popupBatchUpdate.price.selectedRoomType.length == 0 || planSelect.length === 0">
					<v-col class="text-center">
						<p style="color: #484646">{{ $t("NO_DATA") }}</p>
					</v-col>
				</template>
				<!-- <pre>{{popupBatchUpdate.price.hasRoomRate}}</pre> -->
			</template>
			<!-- Nếu cập nhật theo gói bán -->
			<template v-if="popupBatchUpdate.price.updateBy == 'roomplan'">
				<template v-if="popupBatchUpdate.price.priceByRoomPlanList.length > 0">
					<div class="w-100">
						<div class="d-sticky h-header-table d-flex">
							<div class="mr-auto">
								<div class="small-gutters d-flex">
									<div class="text-center font-weight-bold"
										:style="item.code === 'MON' ? 'width: 142px' : 'width: 94px'"
										v-for="item in popupBatchUpdate.daysOfWeek">{{ item.value }}</div>
								</div>
							</div>
							<div class="pb-0 pt-0">
								<div class="small-gutters">
									<div class="d-input-sl text-center font-weight-bold">{{ $t("ADULT") }}</div>
									<div class="d-input-sl text-center font-weight-bold">{{
										$t("_BOOKING_DETAIL.ROOM.CHILDREN") }}</div>
									<div class="d-input-sl text-center font-weight-bold">{{ $t("_BOOKING_DETAIL.ROOM.BABY")
									}}</div>
									<div class="d-input-sl text-center font-weight-bold">{{ $t("GUEST") }}</div>
								</div>
							</div>
						</div>

						<template v-for="(roomplan, roomplanIndex) in popupBatchUpdate.price.priceByRoomPlan.filter((temp) => popupBatchUpdate.price.priceByRoomPlanSelected.includes(temp.id)
							&& temp.roomTypes.filter((rt) => popupBatchUpdate.price.selectedRoomType.includes(rt.id)).length > 0
						)">
							<div class="px-3 pt-3"
								v-for="(roomtype, roomtypeIndex) in roomplan.roomTypes.filter((temp) => popupBatchUpdate.price.selectedRoomType.includes(temp.id))">
								<b-row>
									<v-col md="6" class="py-0">
										<span class="font-weight-bold text-primary pr-2">
											{{ roomtype.roomTypeI18n.find((x) => x.lang == defaultI18n).name }} -
											{{ roomplan.i18ns.find((x) => x.lang == defaultI18n).name }}
										</span>
										<v-menu :close-on-content-click="false" :nudge-width="200" offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn class="btn-outline-custom pr-0" v-bind="attrs" v-on="on" x-small>
													{{ $tc('CHANNEL', roomtype.selectedOta.length.toString()) }}<i
														class="icon-drop-down-list fs-14 ml-2"></i>
												</v-btn>
											</template>

											<v-card>
												<v-list v-if="roomtype.roomRates.length > 5">
													<v-list-item class="px-2">
														<b-form-input v-model="roomtype.textSearch"
															placeholder="Text"></b-form-input>
													</v-list-item>
													<v-list-item class="px-2">
														<p class="mx-3 mt-1 mb-0"> <a class="text-primary"
																@click="roomtype.selectedOta = roomtype.roomRates.map(e => e.ota.id)">{{
																	$t('SELECT_ALL') }}</a>
															| <a class="text-primary" @click="roomtype.selectedOta = []">{{
																$t('UN_SELECT_ALL') }}</a>
														</p>
													</v-list-item>
												</v-list>
												<v-list>
													<v-list-item
														v-for="(ota, indOta) in roomtype.roomRates.filter(item => item.ota.otaI18n.find((x) => x.lang == defaultI18n).name.toString().toLowerCase().includes(roomtype.textSearch.toLowerCase()))"
														style="min-height: 28px !important" class="px-2">
														<v-checkbox v-model="roomtype.selectedOta" class="mt-0 pt-0"
															:label="ota.ota.otaI18n.find((x) => x.lang == defaultI18n).name"
															:value="ota.ota.id"></v-checkbox>
													</v-list-item>
												</v-list>
											</v-card>
										</v-menu>
									</v-col>
									<v-col md="6" class="py-0">
										<div class="text-right">
											<span class="font-weight-bold"
												v-if="roomplanIndex === 0 && roomtypeIndex === 0"> Master
												<v-tooltip top>
													<template v-slot:activator="{ on, attrs }">
														<i class="icon-info fs-16" v-bind="attrs" v-on="on"></i>
													</template>
													<span>{{ $t('TOOLTIP_MASTER') }}</span>
												</v-tooltip>
											</span>
											<div class="d-flex align-center justify-content-end d-multiplier" v-else>
												<div class="mr-1">
													<span class="font-weight-bold"> Master *</span>
												</div>
												<div>
													<currency-ptd
														:classC="'input-multiplier v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
														:options="multiplierOption"
														v-model.lazy="roomtype.multiplier"></currency-ptd>
												</div>
												<span class="font-weight-bold pl-1 pr-1"> + </span>
												<div class="mr-1">
													<currency-ptd
														:classC="'input-plus v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="roomtype.plus"></currency-ptd>
												</div>
												<v-btn color="primary" outlined x-small @click="copyMaster(roomtype)"
													:title="$t('COPY_BY_FOMULAR')">
													<i class="icon-move_down fs-16"></i>
												</v-btn>
											</div>
										</div>
									</v-col>
								</b-row>
								<div class="d-flex mt-1">
									<div class="py-0 mr-auto">
										<div class="small-gutters d-flex">
											<div class="pb-0 pt-0 d-flex align-items-center">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="roomtype.dates.find((x) => x.apply == 'MON').value" />
												<v-btn color="primary" @click="copyPrice(roomtype)" class="ml-1"
													:title="$t('COPY')" icon small><i
														class="icon-content_paste_go fs-16"></i></v-btn>
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="roomtype.dates.find((x) => x.apply == 'TUE').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="roomtype.dates.find((x) => x.apply == 'WED').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="roomtype.dates.find((x) => x.apply == 'THU').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="roomtype.dates.find((x) => x.apply == 'FRI').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="roomtype.dates.find((x) => x.apply == 'SAT').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="roomtype.dates.find((x) => x.apply == 'SUN').value" />
											</div>
										</div>
									</div>
									<div class="py-0">
										<div class="small-gutters">
											<div>
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="roomtype.dates.find((x) => x.apply == 'ADULT').value"></currency-ptd>
											</div>
											<div>
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="roomtype.dates.find((x) => x.apply == 'CHILD').value"></currency-ptd>
											</div>
											<div>
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="roomtype.dates.find((x) => x.apply == 'BABY').value"></currency-ptd>
											</div>
											<div class="mr-0">
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="roomtype.dates.find((x) => x.apply == 'GUEST').value"></currency-ptd>
											</div>
										</div>
									</div>
								</div>
								<v-divider class="mt-3 mb-0"></v-divider>
							</div>
						</template>
					</div>
				</template>
				<template v-else>
					<v-col class="text-center">
						<p style="color: red">{{ $t("ROOMTYPE_HAS_NO_RATEPLAN") }}</p>
					</v-col>
				</template>
			</template>
			<!-- Nếu cập nhật theo kênh OTA -->
			<template v-else-if="popupBatchUpdate.price.updateBy == 'ota'">
				<template v-if="popupBatchUpdate.price.priceByOta.length > 0">
					<div class="w-100">
						<div class="d-sticky h-header-table d-flex">
							<div class="mr-auto">
								<div class="small-gutters d-flex">
									<div class="text-center font-weight-bold"
										:style="item.code === 'MON' ? 'width: 142px' : 'width: 94px'"
										v-for="item in popupBatchUpdate.daysOfWeek" :key="item.value">{{ item.value }}</div>
									<div class="text-center font-weight-bold" style="width: 94px">
										<div class="d-flex">
											<div class="mr-1">Master product</div>
											<v-tooltip top>
												<template v-slot:activator="{ on, attrs }">
													<i class="icon-info fs-14" v-bind="attrs" v-on="on"></i>
												</template>
												<span>{{ $t('TOOLTIP_MASTER') }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
							</div>
							<div class="pb-0 pt-0">
								<div class="small-gutters">
									<div class="d-input-sl text-center font-weight-bold">{{ $t("ADULT") }}</div>
									<div class="d-input-sl text-center font-weight-bold">{{
										$t("_BOOKING_DETAIL.ROOM.CHILDREN") }}</div>
									<div class="d-input-sl text-center font-weight-bold">{{ $t("_BOOKING_DETAIL.ROOM.BABY")
									}}</div>
									<div class="d-input-sl text-center font-weight-bold">{{ $t("GUEST") }}</div>
								</div>
							</div>
						</div>
						<div class="px-3 pt-2" v-for="(roomtype, roomtypeIndex) in popupBatchUpdate.price.priceByOta" :key="roomtype.roomTypeId + roomtypeIndex">
							<span class="font-weight-bold text-primary">
								{{ roomtype.roomTypeI18n.find((x) => x.lang == defaultI18n).name }}
							</span>
							<template v-for="(detail, detailIndex) in roomtype.ratePlans">
								<b-row>
									<v-col md="6" class="py-0">
										<div class="d-flex align-center h-100">
											<div style="font-size: 12px" class="text-primary">
												{{ detail.ratePlanI18ns.find((x) => x.lang == defaultI18n).name }}</div>
										</div>
									</v-col>
									<v-col md="6" class="py-0">
										<div class="text-right">
											<div class="d-flex align-center justify-content-end d-multiplier" v-if="radioOta && radioOta !== (roomtype.roomTypeId + '|' + detail.ratePlanId)">
												<div class="mr-1">
													<span class="font-weight-bold"> Master x</span>
												</div>
												<div>
													<currency-ptd
														:classC="'input-multiplier v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
														:options="multiplierOption"
														v-model.lazy="detail.price.multiplier"></currency-ptd>
												</div>
												<span class="font-weight-bold pl-1 pr-1"> + </span>
												<div class="mr-1">
													<currency-ptd
														:classC="'input-plus v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.price.plus"></currency-ptd>
												</div>
												<v-btn color="primary" outlined x-small @click="copyMaster(detail.price)"
													:title="$t('COPY_BY_FOMULAR')">
													<i class="icon-move_down fs-16"></i>
												</v-btn>
											</div>
										</div>
									</v-col>
								</b-row>
								<div class="d-flex mt-1">
									<div class="py-0 mr-auto">
										<div class="small-gutters d-flex">
											<div class="pb-0 pt-0 d-flex">
												<currency-ptd
													:classC="'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="detail.price.dates.find((x) => x.apply == 'MON').value" />
												<v-btn color="primary" @click="copyPrice(detail.price)" class="ml-1"
													:title="$t('COPY')" icon small><i
														class="icon-content_paste_go fs-16"></i></v-btn>
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="detail.price.dates.find((x) => x.apply == 'TUE').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="detail.price.dates.find((x) => x.apply == 'WED').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="detail.price.dates.find((x) => x.apply == 'THU').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="detail.price.dates.find((x) => x.apply == 'FRI').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="detail.price.dates.find((x) => x.apply == 'SAT').value" />
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'w-input-update v-input__slot mb-0 mx-input py-0 rounded'"
													:options="
														currency == 'VND' ? priceOptionsVi : priceOptionsEn
													" v-model.lazy="detail.price.dates.find((x) => x.apply == 'SUN').value" />
											</div>
											<div class="py-0 pl-5 text-center" style="width: 94px">
												<b-form-radio v-model="radioOta"
												name="some-radios" :value="roomtype.roomTypeId + '|' + detail.ratePlanId"></b-form-radio>
											</div>
										</div>
									</div>
									<div class="py-0">
										<div class="small-gutters">
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="detail.price.dates.find((x) => x.apply == 'ADULT').value"></currency-ptd>
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="detail.price.dates.find((x) => x.apply == 'CHILD').value"></currency-ptd>
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="detail.price.dates.find((x) => x.apply == 'BABY').value"></currency-ptd>
											</div>
											<div class="pb-0 pt-0">
												<currency-ptd
													:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
													:options="availOptions"
													v-model.lazy="detail.price.dates.find((x) => x.apply == 'GUEST').value"></currency-ptd>
											</div>
										</div>
									</div>
								</div>
								<hr class="mb-2" />
							</template>
						</div>
					</div>
				</template>
				<template v-else>
					<v-col md="12" class="text-center">
						<p class="text-danger">{{ $t("OTA_HAS_NO_RATEPLAN") }}</p>
					</v-col>
				</template>
			</template>
			<!-- Cập nhật hàng loạt -->
			<template v-if="popupBatchUpdate.price.updateBy == 'bulkUpdate'">
				<template>
					<div class="w-100">
						<div class="d-sticky h-header-table d-flex">
							<div class="mr-auto">
								<div class="small-gutters d-flex">
									<div class="text-center font-weight-bold"
										:style="item.code === 'MON' ? 'width: 142px' : 'width: 94px'"
										v-for="item in popupBatchUpdate.daysOfWeek" :key="item.value">{{ item.value }}</div>
									<div class="text-center font-weight-bold" style="width: 94px">
										<div class="d-flex">
											<div class="mr-1">Master product</div>
											<v-tooltip top>
												<template v-slot:activator="{ on, attrs }">
													<i class="icon-info fs-14" v-bind="attrs" v-on="on"></i>
												</template>
												<span>{{ $t('TOOLTIP_MASTER') }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
							</div>
							<div class="pb-0 pt-0">
								<div class="small-gutters">
									<div class="d-input-sl text-center font-weight-bold">{{ $t("ADULT") }}</div>
									<div class="d-input-sl text-center font-weight-bold">{{
										$t("_BOOKING_DETAIL.ROOM.CHILDREN") }}</div>
									<div class="d-input-sl text-center font-weight-bold">{{ $t("_BOOKING_DETAIL.ROOM.BABY")
									}}</div>
									<div class="d-input-sl text-center font-weight-bold">{{ $t("GUEST") }}</div>
								</div>
							</div>
						</div>
						<template
						 v-for="(room, roomIndex) in popupBatchUpdate.price.hasRoomRate.filter((temp) => popupBatchUpdate.price.selectedRoomType.includes(temp.roomTypeId))
							.filter(rr => rr.roomRates.filter(item => planSelect.includes(item.ratePlansId) &&
								item.ota.filter(ota => popupBatchUpdate.price.priceByOtasSelected.includes(ota.ota.id)).length > 0))">
							<div class="px-3 pt-2" v-for="(plan, indexPlan) in room.roomRates.filter(item => planSelect.includes(item.ratePlansId)
								&& item.ota.filter(ota => popupBatchUpdate.price.priceByOtasSelected.includes(ota.ota.id)).length > 0)" :key="plan.ratePlansId + roomIndex + indexPlan">
								<span class="font-weight-bold text-primary">
									{{ room.romTypeNameI18ns.find((x) => x.lang == defaultI18n).name }} - {{
										plan.romPlanNameI18ns.find((x) => x.lang == defaultI18n).name }}
								</span>
								<p v-if="`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors" class="protection-rate-error text-danger mb-1">{{updateErrors[`${room.roomTypeId}_${plan.ratePlansId}`]}}</p>
								<div v-for="(detail, indexDetail) in plan.ota.filter(ota => popupBatchUpdate.price.priceByOtasSelected.includes(ota.ota.id))" :key="detail.ota.id+ roomIndex + indexPlan + indexDetail"
									class="mb-2">
									<b-row>
										<v-col md="6" class="py-0">
											<div style="font-size: 13px" class="d-flex align-center h-100 text-primary">
												{{ detail.ota.otaI18n.find((x) => x.lang == defaultI18n).name }}
											</div>
										</v-col>
										<v-col md="6" class="py-0">
											<div class="text-right d-flex justify-content-end">
												<!-- <span class="font-weight-bold"
													v-if="roomIndex === 0 && indexPlan === 0 && indexDetail === 0"> Master
													<v-tooltip top>
														<template v-slot:activator="{ on, attrs }">
															<i class="icon-info fs-16" v-bind="attrs" v-on="on"></i>
														</template>
														<span>{{ $t('TOOLTIP_MASTER') }}</span>
													</v-tooltip>
												</span> -->
												<div class="d-flex align-center justify-content-end d-multiplier" v-if="radioBulkUpdate && radioBulkUpdate !== (room.roomTypeId + '|' + plan.ratePlansId + '|' + detail.ota.id)">
													<div class="mr-1">
														<span class="font-weight-bold"> Master *</span>
													</div>
													<div>
														<currency-ptd
															:classC="'input-multiplier v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
															:options="multiplierOption"
															v-model.lazy="detail.multiplier"></currency-ptd>
													</div>
													<span class="font-weight-bold pl-1 pr-1"> + </span>
													<div class="mr-1">
														<currency-ptd
															:classC="'input-plus v-input__slot mb-0 mx-input pr-1 py-0 rounded'"
															:options="
																currency == 'VND' ? priceOptionsVi : priceOptionsEn
															" v-model.lazy="detail.plus"></currency-ptd>
													</div>
													<v-btn color="primary" outlined x-small @click="copyMaster(detail)"
														:title="$t('COPY_BY_FOMULAR')">
														<i class="icon-move_down fs-16"></i>
													</v-btn>
												</div>
												<div class="ml-3 d-flex align-center">
													<v-btn color="primary" x-small class="ml-1" :title="$t('COPY')"
														@click="copyRow(detail.dates)">
														<i class="icon-copy_all fs-16"></i>
													</v-btn>
													<v-btn color="primary" x-small class="ml-1" :title="$t('PASTE')"
														@click="pasteMaster(detail)" v-if="objectCopy">
														<i class="icon-content_paste fs-16"></i>
													</v-btn>
												</div>
											</div>
										</v-col>
									</b-row>
									<div class="d-flex mt-1">
										<div class="py-0 mr-auto">
											<div class="small-gutters d-flex">
												<div class="pb-0 pt-0 d-flex align-items-center">
													<currency-ptd
														:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, detail.dates.find((x) => x.apply == 'MON').value) 
															? 'protection-border-danger' 
															: ''
														].filter(Boolean).join(' ')"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.dates.find((x) => x.apply == 'MON').value" />
													<v-btn color="primary" @click="copyPrice(detail)" class="ml-1"
														:title="$t('COPY')" icon small><i
															class="icon-content_paste_go fs-16"></i></v-btn>
												</div>
												<div class="pb-0 pt-0">
													<currency-ptd
														:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, detail.dates.find((x) => x.apply == 'TUE').value) 
															? 'protection-border-danger' 
															: ''
														].filter(Boolean).join(' ')"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.dates.find((x) => x.apply == 'TUE').value" />
												</div>
												<div class="pb-0 pt-0">
													<currency-ptd
														:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, detail.dates.find((x) => x.apply == 'WED').value) 
															? 'protection-border-danger' 
															: ''
														].filter(Boolean).join(' ')"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.dates.find((x) => x.apply == 'WED').value" />
												</div>
												<div class="pb-0 pt-0">
													<currency-ptd
														:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, detail.dates.find((x) => x.apply == 'THU').value) 
															? 'protection-border-danger' 
															: ''
														].filter(Boolean).join(' ')"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.dates.find((x) => x.apply == 'THU').value" />
												</div>
												<div class="pb-0 pt-0">
													<currency-ptd
														:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, detail.dates.find((x) => x.apply == 'FRI').value) 
															? 'protection-border-danger' 
															: ''
														].filter(Boolean).join(' ')"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.dates.find((x) => x.apply == 'FRI').value" />
												</div>
												<div class="pb-0 pt-0">
													<currency-ptd
														:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, detail.dates.find((x) => x.apply == 'SAT').value) 
															? 'protection-border-danger' 
															: ''
														].filter(Boolean).join(' ')"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.dates.find((x) => x.apply == 'SAT').value" />
												</div>
												<div class="pb-0 pt-0">
													<currency-ptd
														:classC="[
														'w-input-update v-input__slot mb-0 mx-input py-0 rounded text-right', 
														`${room.roomTypeId}_${plan.ratePlansId}` in updateErrors && 
														protectionRateInvalid(room.priceMin, room.priceMax, detail.dates.find((x) => x.apply == 'SUN').value) 
															? 'protection-border-danger' 
															: ''
														].filter(Boolean).join(' ')"
														:options="
															currency == 'VND' ? priceOptionsVi : priceOptionsEn
														" v-model.lazy="detail.dates.find((x) => x.apply == 'SUN').value" />
												</div>
												<div class="py-0 pl-5 text-center" style="width: 94px">
													<b-form-radio v-model="radioBulkUpdate"
													name="some-radios-bulkUpdate" :value="room.roomTypeId + '|' + plan.ratePlansId + '|' + detail.ota.id"></b-form-radio>
												</div>
											</div>
										</div>
										<div class="py-0">
											<div class="small-gutters">
												<div>
													<currency-ptd
														:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
														:options="availOptions"
														v-model.lazy="detail.dates.find((x) => x.apply == 'ADULT').value"
														:id="detail.roomrateId+'-ADULT'" 
														@input="changeQuantity(detail)" ></currency-ptd>
												</div>
												<div>
													<currency-ptd
														:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
														:options="availOptions"
														v-model.lazy="detail.dates.find((x) => x.apply == 'CHILD').value"
														:id="detail.roomrateId+'-CHILD'" 
														@input="changeQuantity(detail)" ></currency-ptd>
												</div>
												<div>
													<currency-ptd
														:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
														:options="availOptions"
														v-model.lazy="detail.dates.find((x) => x.apply == 'BABY').value"
														:id="detail.roomrateId+'-BABY'" 
														@input="changeQuantity(detail)" ></currency-ptd>
												</div>
												<div class="mr-0">
													<currency-ptd
														:classC="'d-input-sl v-input__slot mb-0 mx-input py-0 pr-1 rounded text-right'"
														:options="availOptions"
														v-model.lazy="detail.dates.find((x) => x.apply == 'GUEST').value"
														:id="detail.roomrateId+'-GUEST'" 
														@input="changeQuantity(detail)" ></currency-ptd>
												</div>
											</div>
										</div>
									</div>
								</div>
								<hr class="mb-2" />
							</div>
						</template>
					</div>
				</template>
				<template v-if="popupBatchUpdate.price.selectedRoomType.length === 0 || planSelect.length === 0 || popupBatchUpdate.price.priceByOtasSelected.length === 0">
					<v-col class="text-center">
						<p style="color: #484646">{{ $t("NO_DATA") }}</p>
					</v-col>
				</template>
				<!-- <pre>{{popupBatchUpdate.price.hasRoomRate}}</pre> -->
			</template>
		</v-row>
		<div class="text-right pt-3 d-flex align-items-center" v-if="!popupBatchUpdate.isLoading">
			<i class="mb-0 text-danger mr-auto"> {{ $t("UPDATE_PRICE_NOTE") }} </i>
			<v-btn color="primary" @click="confirmUpdatePrice()">
				<template>{{ $t("UPDATE") }}</template>
			</v-btn>

		</div>
		<delete-dialog @deleteItem="openPopupRoomType" :maxWidth="325" ref="openPopupRoomType">
          <span slot="title">{{ $t("CONFIRM_DELETE_DATA_ENTERED") }}?</span>
        </delete-dialog>

        <delete-dialog @deleteItem="openPopupBulkUpdate" :maxWidth="325" ref="openPopupBulkUpdate">
          <span slot="title">{{ $t("CONFIRM_DELETE_DATA_ENTERED") }}?</span>
        </delete-dialog>

        <delete-dialog @deleteItem="openPopupOta" :maxWidth="325"
          ref="openPopupOta">
          <span slot="title">{{ $t("CONFIRM_DELETE_DATA_ENTERED") }}?</span>
        </delete-dialog>
		<v-dialog v-model="dialogWarning" :persistent="true" width="500" >
			<v-toolbar class="toolbar-update" dense >
				<v-toolbar-title class="text-primary fs-15">
				<strong>{{ $t('WARNING') }}</strong>
				</v-toolbar-title>
			</v-toolbar>
			<div class="content-update">
				<label class="s-label">
				{{ $t('TXT_WARNING_OVER') }}
				</label>
				<div class="mt-3 text-center">
					<v-btn color="primary" @click="closeWarning">
					{{ $t("CONFIRM") }}
					</v-btn>
				</div>
			</div>
		</v-dialog>
	</div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { service } from "@/_services/SaleRoom/room-plan.service.js";
const toLower = text => {
	return text.toString().toLowerCase()
}
export default {
	components: {
		"currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
		"delete-dialog": () => import('@/components/Utils/DeleteDialog.vue'),
	},
	data() {
		return {
			dialogWarning: false,
			currency: JSON.parse(localStorage.getItem("currency")),
			multiplierOption: {
				prefix: "",
				locale: "vi",
				length: 3,
				precision: 2,
			},
			availOptions: {
				locale: "vi",
				length: 3,
				precision: 0,
			},
			popupBatchUpdate: {
				isLoading: true,
				price: {
					hasRoomRate: [],
					hasRoomRateBulkUpdate: [],
					roomRateSelect: [],
					selectedRoomType: [],
					value: {
						MON: null,
						TUE: null,
						WED: null,
						THU: null,
						FRI: null,
						SAT: null,
						SUN: null,
					},
					updateBy: "bulkUpdate",
					priceByOta: [],
					priceByOtaSelected: null,
					priceByOtasSelected: [],
					priceByRoomPlanList: [],
					priceByRoomPlan: [],
					priceByRoomPlanSelected: [],
					selectedRoomTypes: [],
				},
				daysOfWeek: [
					{ code: "MON", value: this.$t("MONDAY") },
					{ code: "TUE", value: this.$t("TUESDAY") },
					{ code: "WED", value: this.$t("WEDNESDAY") },
					{ code: "THU", value: this.$t("THURSDAY") },
					{ code: "FRI", value: this.$t("FRIDAY") },
					{ code: "SAT", value: this.$t("SATURDAY") },
					{ code: "SUN", value: this.$t("SUNDAY") },
				],
			},
			listRoom: [],
			currentDate: moment().startOf("day").toDate(),
			selectedDatePicker: moment().startOf("day").format("YYYY-MM-DD"),
			listOTA: [],
			selectedOTA: null,
			systemLang: this.$i18n.locale,
			selectedRoom: -1,
			objectCopy: null,
			planList: [],
			planSelect: [],
			isOverwrite: true,
			dialogUpdateRate: false,
			isOver: false,

			radioRoomType: null,
			radioBulkUpdate: null,
			radioOta: null,
			updateErrors: {},
		};
	},
	computed: {
	},
	created() {
		this.initialize();
	},
	watch: {
		radioRoomType(newValue, oldValue) {
			if (oldValue && newValue) {
				let check = false;
				this.popupBatchUpdate.price.hasRoomRate.filter((x) => this.popupBatchUpdate.price.selectedRoomType.includes(x.roomTypeId)).forEach(hr => {
					hr.roomRates.forEach(rr => {
						rr.dates.forEach(d => {
							if(d.apply !== 'ADULT' && d.apply !== 'CHILD' && d.apply !== 'BABY' && d.apply !== 'GUEST' && d.value) {
								check = true;
								return
							}
						})
					})
				})
				if (check) {
					this.$refs.openPopupRoomType.open()
				}
			}
		},
		radioBulkUpdate(newValue, oldValue) {
			if (oldValue && newValue) {
				let check = false;
				this.popupBatchUpdate.price.hasRoomRate.filter((x) => this.popupBatchUpdate.price.selectedRoomType.includes(x.roomTypeId)).forEach(hr => {
					hr.roomRates.filter(item => this.planSelect.includes(item.ratePlansId)).forEach(rr => {
						rr.ota.filter((temp) => this.popupBatchUpdate.price.priceByOtasSelected.includes(temp.ota.id)).forEach(o => {
							o.dates.forEach(d => {
								if(d.apply !== 'ADULT' && d.apply !== 'CHILD' && d.apply !== 'BABY' && d.apply !== 'GUEST' && d.value) {
									check = true;
									return
								}
							})
						})
					})
				})
				if (check) {
					this.$refs.openPopupBulkUpdate.open()
				}
			}
		},
		radioOta(newValue, oldValue) {
			if (oldValue && newValue) {
				let check = false;
				this.popupBatchUpdate.price.priceByOta.forEach(hr => {
					hr.ratePlans.forEach(rr => {
						rr.price.dates.forEach(d => {
							if(d.apply !== 'ADULT' && d.apply !== 'CHILD' && d.apply !== 'BABY' && d.apply !== 'GUEST' && d.value) {
								check = true;
								return
							}
						})
					})
				})
				if (check) {
					this.$refs.openPopupOta.open()
				}
			}
		},
	},
	methods: {
		checkValidate() {
			this.updateErrors = {};
			let errors = [];
			const selectedRoomType = this.popupBatchUpdate.price.hasRoomRate
			.filter((x) => this.popupBatchUpdate.price.selectedRoomType.includes(x.roomTypeId));
			
			selectedRoomType.forEach((y) => {
				//lấy priceMin, priceMax của từng loại phòng
				const priceMax = y.priceMax;
				const priceMin = y.priceMin;
				const message = priceMax != null && priceMin != null ? 
					this.$t("SAFE_PRICE_RANGE.PROTECTION_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax), priceMin: this.formatCurrencyWithSymbol(priceMin)}) :
						priceMax != null ? 
						this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(priceMax)}) :
						this.$t("SAFE_PRICE_RANGE.MINIMUM_RATE_INPUT_INVALID", {priceMin: this.formatCurrencyWithSymbol(priceMin)});
				
				const roomRates = y.roomRates.filter(item => this.planSelect.includes(item.ratePlansId));
				roomRates.forEach((z) => {
					if (!errors.some(error => error.id === `${y.roomTypeId}_${z.ratePlansId}`)) {
						if (this.popupBatchUpdate.price.updateBy == "bulkUpdate") {
							const otas = z.ota.filter((temp) => this.popupBatchUpdate.price.priceByOtasSelected.includes(temp.ota.id));
							otas.some(({ dates }) =>
								dates.some(({ apply, value }) => {
									if (
										["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].includes(apply) &&
										value &&
										((priceMin != null && parseFloat(priceMin) > parseFloat(value)) ||
										(priceMax != null && parseFloat(priceMax) < parseFloat(value)))
									) {
										errors.push({ id: `${y.roomTypeId}_${z.ratePlansId}`, message });
										return true;
									}
									return false;
								})
							);
						}
						if (this.popupBatchUpdate.price.updateBy == "roomtype") {
							z.dates.some(({ apply, value }) => {
								if (
									["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].includes(apply) &&
									value &&
									((priceMin != null && parseFloat(priceMin) > parseFloat(value)) ||
									(priceMax != null && parseFloat(priceMax) < parseFloat(value)))
								) {
									errors.push({ id: `${y.roomTypeId}_${z.ratePlansId}`, message });
									return true;
								}
								return false;
							})
						}
					}
				});
			});
			
			if (errors.length > 0) {
				const errorsObject = errors.reduce((acc, item) => {
					acc[item.id] = item.message;
					return acc;
				}, {});
				this.updateErrors = errorsObject;
			}
			return Object.keys(this.updateErrors).length == 0;
		},
		closeWarning() {
			this.planSelect = [];
			this.dialogWarning = false
		},
		checkProductUpdate() {
			
			let dataUpdate = 0;
			if (this.popupBatchUpdate.price.updateBy === 'roomtype' || this.popupBatchUpdate.price.updateBy === 'bulkUpdate') {
				 this.popupBatchUpdate.price.hasRoomRate.forEach(e => {
					if ( this.popupBatchUpdate.price.selectedRoomType.includes(e.roomTypeId)) {
						
						e.roomRates.forEach(rr => {
							if( this.planSelect.includes(rr.ratePlansId)) {
								dataUpdate += 1;
							}
						})
					}
				 });
			}
			if (dataUpdate > 50) {
				this.dialogWarning = true;
			}
		},
		openPopupRoomType() {
			this.popupBatchUpdate.price.hasRoomRate.forEach(hr => {
				hr.roomRates.forEach(rr => {
					rr.dates.forEach(d => {
						if(d.apply !== 'ADULT' && d.apply !== 'CHILD' && d.apply !== 'BABY' && d.apply !== 'GUEST') {
							d.value = null;
						}
					})
				})
			})
		},
		openPopupBulkUpdate() {
			this.popupBatchUpdate.price.hasRoomRate.forEach(hr => {
				hr.roomRates.forEach(rr => {
					rr.ota.forEach(o => {
						o.dates.forEach(d => {
							if(d.apply !== 'ADULT' && d.apply !== 'CHILD' && d.apply !== 'BABY' && d.apply !== 'GUEST') {
								d.value = null;
							}
						})
					})
				})
			})
		},
		openPopupOta() {
			this.popupBatchUpdate.price.priceByOta.forEach(hr => {
				hr.ratePlans.forEach(rr => {
					rr.price.dates.forEach(d => {
						if(d.apply !== 'ADULT' && d.apply !== 'CHILD' && d.apply !== 'BABY' && d.apply !== 'GUEST') {
							d.value = null;
						}
					})
				})
			})
		},
		remove(index, arr) {
			if (index >= 0) arr.splice(index, 1)
		},
		getTypeUpdate() {
			if (this.popupBatchUpdate.price.updateBy === 'roomtype' || this.popupBatchUpdate.price.updateBy === 'bulkUpdate') {
				this.getAllRoomDefault()
			} else if (this.popupBatchUpdate.price.updateBy === 'roomplan') {
				this.getRateByRoomPlan();
			} else {
				this.getRateByOta(this.selectedOTA);
			}
			this.updateErrors = {};
		},
		async initialize(isSearch) {
			this.popupBatchUpdate.isLoading = true;
			// Nếu là search thì không lấy lại list OTA nữa, ko dùng OTA đầu tiên như khi mới vào.
			this.currency = this.priceOptionsVi.suffix;

			// this.getRateByRoomPlan();
			// Lấy list các OTA, nếu search thì ko lấy lại nữa.
			if (!isSearch) {
				await syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
					if (res.responseCode === 0) {
						this.listOTA = res.data.filter((x) => x.otaCode !== 'EZ_PMS').map((x) => {
							return {
								value: x.id,
								text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
								date: this.inDays(new Date(), new Date(x.endDate)),
								endDate: moment(x.endDate).format("DD/MM/YYYY HH:mm"),
								code: x.otaCode
							};
						});
						this.listOTA = this.listOTA.filter((x) => x.value);
						this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
						this.selectedOTA = localStorage.getItem("currentOTARoomSale") && this.listOTA.find((x) => x.value == localStorage.getItem("currentOTARoomSale"))
							? JSON.parse(localStorage.getItem("currentOTARoomSale"))
							: null;
						// Gán OTA đầu tiên để sử dụng lần đầu tiên, với điều kiện có list OTA và chưa tồn tại OTA trong local storage
						if (
							this.listOTA.length > 0 &&
							this.listOTA[0].value &&
							(this.selectedOTA == null || !this.listOTA.find((x) => x.value == this.selectedOTA))
						) {
							this.selectedOTA = this.listOTA[0].value;
						} else {
							// _alert( 'null', this.$t('OTA_LIST_EMPTY'), false);
						}
						this.$forceUpdate()
					} else {
						_alert(res, this.$t(res.data), false);
					}
				});
			}
			this.popupBatchUpdate.price.priceByOtaSelected =  this.selectedOTA;
			this.getAllRoomDefault();
			// // Select OTA đầu tiên dùng cho màn cập nhật giá theo OTA

			// this.getRateByOta(this.selectedOTA);
		},
		loadListRoom(data) {
			this.listRoom = [];
			this.listRoom = this.listRoom.concat(
				data.map((room) => {
					return {
						value: room.id,
						text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
					};
				})
			);
			this.popupBatchUpdate.isLoading = false;
		},
		inDays(d1, d2) {
			var t2 = d2.getTime();
			var t1 = d1.getTime();

			return parseInt((t2 - t1) / (24 * 3600 * 1000));
		},
		copyRow(detail) {
			this.objectCopy = [...detail];
		},
		pasteMaster(detail) {
			if (this.objectCopy) {
				detail.dates[0].value = this.objectCopy[0].value;
				detail.dates[1].value = this.objectCopy[1].value;
				detail.dates[2].value = this.objectCopy[2].value;
				detail.dates[3].value = this.objectCopy[3].value;
				detail.dates[4].value = this.objectCopy[4].value;
				detail.dates[5].value = this.objectCopy[5].value;
				detail.dates[6].value = this.objectCopy[6].value;
			}
		},
		copyPrice(detail) {
			detail.dates[1].value = detail.dates[0].value;
			detail.dates[2].value = detail.dates[0].value;
			detail.dates[3].value = detail.dates[0].value;
			detail.dates[4].value = detail.dates[0].value;
			detail.dates[5].value = detail.dates[0].value;
			detail.dates[6].value = detail.dates[0].value;
		},
		async getRateByRoomPlan() {
			this.popupBatchUpdate.isLoading = true;
			const roomRateUpdateStore = JSON.parse(localStorage.getItem("roomRateUpdate"));
			await restriction.getAllRoomPlanHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					if (res.data.length > 0) {
						res.data.forEach((x) => {
							let temp = {
								id: x.id,
								roomTypes: [],
								i18ns: x.i18ns,
							};
							x.roomTypes.forEach((y) => {
								let temp2 = {
									roomTypeI18n: y.roomTypeI18n,
									roomRates: [],
									id: y.id,
									dates: [
										{
											apply: "MON",
											value: null,
										},
										{
											apply: "TUE",
											value: null,
										},
										{
											apply: "WED",
											value: null,
										},
										{
											apply: "THU",
											value: null,
										},
										{
											apply: "FRI",
											value: null,
										},
										{
											apply: "SAT",
											value: null,
										},
										{
											apply: "SUN",
											value: null,
										},
										{
											apply: "ADULT",
											value: 1,
										},
										{
											apply: "CHILD",
											value: 0,
										},
										{
											apply: "BABY",
											value: 0,
										},
										{
											apply: "GUEST",
											value: 1,
										},
									],
									multiplier: 1,
									plus: 0,
									selectedOta: [],
									textSearch: ''
								};
								temp2.selectedOta = roomRateUpdateStore.OtaId ? y.roomRates.map(ota => ota.ota.id).includes(roomRateUpdateStore.OtaId) ? [roomRateUpdateStore.OtaId] : [] : [],


									y.roomRates.forEach((z) => {
										if (!z.linkedRoomRateId) {
											let temp3 = {
												id: z.id,
												ota: z.ota,
												linkedRoomRateId: z.linkedRoomRateId
											};
											temp2.roomRates.push(temp3);
										}
									});
								if (temp2.roomRates.length > 0) {
									temp.roomTypes.push(temp2);
								}

							});
							if (temp.roomTypes.length > 0) {
								this.popupBatchUpdate.price.priceByRoomPlan.push(temp);
							}

						});

						// Tạo list cho select gói bán khi cập nhật giá.
						res.data.forEach((x) => {
							let temp = {
								value: x.id,
								text: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
							};
							this.popupBatchUpdate.price.priceByRoomPlanList.push(temp);

						});
						this.popupBatchUpdate.price.priceByRoomPlanSelected = roomRateUpdateStore.planId ? [roomRateUpdateStore.planId] : [];
					} else {
						this.popupBatchUpdate.price.priceByRoomPlanList = [];
					}
				}
				this.popupBatchUpdate.isLoading = false;
			});
		},
		async getAllRoomDefault() {
			this.popupBatchUpdate.isLoading = true;
			this.popupBatchUpdate.price.selectedRoomType = [];
			this.planList = [];
			const roomRateUpdateStore = JSON.parse(localStorage.getItem("roomRateUpdate"));
			await restriction.getAllRoomTyeHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					// List phòng đã có room rate cho cập nhật giá và giá đặc biệt
					this.popupBatchUpdate.price.hasRoomRate = [];
					res.data.forEach((x) => {
						var temp = {
							roomTypeId: x.id,
							romTypeNameI18ns: x.roomTypeI18n,
							roomRates: [],
							priceMin: x.priceMin,
              				priceMax: x.priceMax
						};
						x.ratePlans.forEach((y) => {
							let plan = {
								value: y.id,
								text: y.i18ns.find((y) => y.lang == this.defaultI18n).name,
							};
							this.planList.push(plan);
							this.planList = Array.from(new Set(this.planList.map(JSON.stringify))).map(JSON.parse)
							var temp2 = [];
							y.roomRates.filter(o => o.ota.otaCode !== 'EZ_PMS').forEach((z) => {
								if (!z.linkedRoomRateId) {
									temp2.push({
										roomrateId: z.id,
										dates: [
											{
												apply: "MON",
												value: null,
											},
											{
												apply: "TUE",
												value: null,
											},
											{
												apply: "WED",
												value: null,
											},
											{
												apply: "THU",
												value: null,
											},
											{
												apply: "FRI",
												value: null,
											},
											{
												apply: "SAT",
												value: null,
											},
											{
												apply: "SUN",
												value: null,
											},
											{
												apply: "ADULT",
												value: z.adultsIncluded,
											},
											{
												apply: "CHILD",
												value: z.childrenIncluded,
											},
											{
												apply: "BABY",
												value: z.babiesIncluded,
											},
											{
												apply: "GUEST",
												value: z.guestsIncluded,
											},
										],
										ota: z.ota,
										multiplier: 1,
										plus: 0,
									});
								}
							});
							if (temp2.length > 0) {
								let obj = {
									romPlanNameI18ns: y.i18ns,
									ota: temp2,
									ratePlansId: y.id,
									dates: [
										{
											apply: "MON",
											value: null,
										},
										{
											apply: "TUE",
											value: null,
										},
										{
											apply: "WED",
											value: null,
										},
										{
											apply: "THU",
											value: null,
										},
										{
											apply: "FRI",
											value: null,
										},
										{
											apply: "SAT",
											value: null,
										},
										{
											apply: "SUN",
											value: null,
										},
										{
											apply: "ADULT",
											value: temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId) ? temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId).dates.find(d => d.apply === 'ADULT').value : 1,
										},
										{
											apply: "CHILD",
											value: temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId) ? temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId).dates.find(d => d.apply === 'CHILD').value : 0,
										},
										{
											apply: "BABY",
											value: temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId) ? temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId).dates.find(d => d.apply === 'BABY').value : 0,
										},
										{
											apply: "GUEST",
											value: temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId) ? temp2.find(e => e.ota.id === roomRateUpdateStore.OtaId).dates.find(d => d.apply === 'GUEST').value : 1,
										},
									],
									multiplier: 1,
									plus: 0,
									selectedOta: roomRateUpdateStore.OtaId && roomRateUpdateStore.OtaId != -1 ? temp2.map(ota => ota.ota.id).includes(roomRateUpdateStore.OtaId) ? [roomRateUpdateStore.OtaId] : [] 
													: roomRateUpdateStore.OtaId && roomRateUpdateStore.OtaId == -1 ? temp2.map(ota => ota.ota.id) : [],
									textSearch: ''
								};
								temp.roomRates.push(obj);
							}

						});
						this.popupBatchUpdate.price.hasRoomRate.push(temp);

					});
					this.loadListRoom(res.data);
					if (roomRateUpdateStore.roomId && roomRateUpdateStore.roomId != -1) {
						this.popupBatchUpdate.price.selectedRoomType = [roomRateUpdateStore.roomId];
					} else {
						this.popupBatchUpdate.price.selectedRoomType = []
					}
					// else if(roomRateUpdateStore.roomId && roomRateUpdateStore.roomId == -1) {
					// 	this.popupBatchUpdate.price.selectedRoomType = this.listRoom.map(e => e.value);
					// } else {
					// 	this.popupBatchUpdate.price.selectedRoomType.push(this.popupBatchUpdate.price.hasRoomRate[0].roomTypeId);
					// }

					if (roomRateUpdateStore.planId && roomRateUpdateStore.planId != -1) {
						this.planSelect = [roomRateUpdateStore.planId];
					} else if(roomRateUpdateStore.planId && roomRateUpdateStore.planId == -1) {
						this.planSelect = [];
					} else {
						this.planSelect = [];
					}

					if (roomRateUpdateStore.OtaId && roomRateUpdateStore.OtaId == -1) {
						this.popupBatchUpdate.price.priceByOtasSelected = [];
					} else if(roomRateUpdateStore.OtaId && this.listOTA.find((x) => x.value == roomRateUpdateStore.OtaId)) {
						this.popupBatchUpdate.price.priceByOtasSelected = [roomRateUpdateStore.OtaId];
					} else {
						this.popupBatchUpdate.price.priceByOtasSelected = [];
					}
					
				}
			});
		},
		async getRateByOta(otaId) {
			this.radioOta = null;
			this.popupBatchUpdate.isLoading = true;
			await restriction.getAllOtaHasRoomRate(otaId).then((res) => {
				if (res.responseCode == 0) {
					this.popupBatchUpdate.price.priceByOta = [];
					if (res.data.length > 0) {
						res.data.forEach((x) => {
							let temp = {
								roomTypeId: x.id,
								roomTypeI18n: x.roomTypeI18n,
								ratePlans: [],
							};
							x.ratePlans.forEach((y) => {
								if (!y.roomRates[0].linkedRoomRateId) {
									let temp2 = {
										ratePlanId: y.id,
										ratePlanI18ns: y.i18ns,
										price: {
											id: y.roomRates[0].id,
											dates: [
												{
													apply: "MON",
													value: null,
												},
												{
													apply: "TUE",
													value: null,
												},
												{
													apply: "WED",
													value: null,
												},
												{
													apply: "THU",
													value: null,
												},
												{
													apply: "FRI",
													value: null,
												},
												{
													apply: "SAT",
													value: null,
												},
												{
													apply: "SUN",
													value: null,
												},
												{
													apply: "ADULT",
													value: y.roomRates[0].adultsIncluded,
												},
												{
													apply: "CHILD",
													value: y.roomRates[0].childrenIncluded,
												},
												{
													apply: "BABY",
													value: y.roomRates[0].babiesIncluded,
												},
												{
													apply: "GUEST",
													value: y.roomRates[0].guestsIncluded,
												},
											],
											multiplier: 1,
											plus: 0
										}
									};
									temp.ratePlans.push(temp2);
								}
							});
							if (temp.ratePlans.length > 0) {
								this.popupBatchUpdate.price.priceByOta.push(temp);
							}

						});
					} else {
						this.popupBatchUpdate.price.priceByOta = [];
					}
					this.popupBatchUpdate.isLoading = false;
				}
			});
		},
		changeRoomSelect(value) {
			this.radioBulkUpdate = null;
			this.radioRoomType = null;
		},
		copyMaster(detail) {
			let arrMap = [];
			if (this.popupBatchUpdate.price.updateBy == 'bulkUpdate') {
				if(!this.radioBulkUpdate) return
				const arrUpdate = [];
				// this.popupBatchUpdate.price.hasRoomRate.forEach(r => {
				// 	if (this.popupBatchUpdate.price.selectedRoomType.includes(r.roomTypeId)) {
				// 		r.roomRates.forEach(rp => {
				// 			if (this.planSelect.includes(rp.ratePlansId)) {
				// 				rp.ota.forEach(rr => {
				// 					if (this.popupBatchUpdate.price.priceByOtasSelected.includes(rr.ota.id)) {
				// 						arrUpdate.push(rr.dates)
				// 					}
				// 				})
				// 			}
				// 		})
				// 	}
				// })
				this.popupBatchUpdate.price.hasRoomRate.forEach(r => {
					if (r.roomTypeId === this.radioBulkUpdate.split("|")[0]) {
						r.roomRates.forEach(rp => {
							if (rp.ratePlansId === this.radioBulkUpdate.split("|")[1]) {
								rp.ota.forEach(rr => {
									if (rr.ota.id === this.radioBulkUpdate.split("|")[2]) {
										arrUpdate.push(rr.dates)
									}
								})
							}
						})
					}
				})
				arrMap = arrUpdate[0].map(e => {
					if (!['ADULT', 'CHILD', 'BABY', 'GUEST'].includes(e.apply)) {
						return {
							apply: e.apply,
							value: e.value * detail.multiplier + +detail.plus
						};
					} else {
						let value = 0;
						switch (e.apply) {
							case 'ADULT':
								value = detail.dates.find((x) => x.apply == 'ADULT').value;
								break;
							case 'CHILD':
								value = detail.dates.find((x) => x.apply == 'CHILD').value;
								break;
							case 'BABY':
								value = detail.dates.find((x) => x.apply == 'BABY').value;
								break;
							case 'GUEST':
								value = detail.dates.find((x) => x.apply == 'GUEST').value;
								break;
						}
						return {
							apply: e.apply,
							value: value
						};
					}
				});
				detail.dates = [...arrMap];
			} else if (this.popupBatchUpdate.price.updateBy == 'roomplan') {
				const arrUpdate = [];
				this.popupBatchUpdate.price.priceByRoomPlan.forEach(r => {
					if (this.popupBatchUpdate.price.priceByRoomPlanSelected.includes(r.id)) {
						r.roomTypes.forEach(rp => {
							if (this.popupBatchUpdate.price.selectedRoomType.includes(rp.id)) {
								arrUpdate.push(rp.dates)
							}
						})
					}
				})
				arrMap = arrUpdate[0].map(e => {
					if (!['ADULT', 'CHILD', 'BABY', 'GUEST'].includes(e.apply)) {
						return {
							apply: e.apply,
							value: e.value * detail.multiplier + +detail.plus
						};
					} else {
						let value = 0;
						switch (e.apply) {
							case 'ADULT':
								value = detail.dates.find((x) => x.apply == 'ADULT').value;
								break;
							case 'CHILD':
								value = detail.dates.find((x) => x.apply == 'CHILD').value;
								break;
							case 'BABY':
								value = detail.dates.find((x) => x.apply == 'BABY').value;
								break;
							case 'GUEST':
								value = detail.dates.find((x) => x.apply == 'GUEST').value;
								break;
						}
						return {
							apply: e.apply,
							value: value
						};
					}
				});
				detail.dates = [...arrMap];
			} else if (this.popupBatchUpdate.price.updateBy == 'roomtype') {
				if(!this.radioRoomType) return
				const arrUpdate = [];
				// this.popupBatchUpdate.price.hasRoomRate.forEach(r => {
				// 	if (this.popupBatchUpdate.price.selectedRoomType.includes(r.roomTypeId)) {
				// 		r.roomRates.forEach(rp => {
				// 			if (this.planSelect.includes(rp.ratePlansId)) {
				// 				arrUpdate.push(rp.dates)
				// 			}
				// 		})
				// 	}
				// })
				this.popupBatchUpdate.price.hasRoomRate.forEach(r => {
					if (r.roomTypeId === this.radioRoomType.split("|")[0]) {
						r.roomRates.forEach(rp => {
							if (rp.ratePlansId === this.radioRoomType.split("|")[1]) {
								arrUpdate.push(rp.dates)
							}
						})
					}
				})
				console.log(arrUpdate)
				arrMap = arrUpdate[0].map(e => {
					if (!['ADULT', 'CHILD', 'BABY', 'GUEST'].includes(e.apply)) {
						return {
							apply: e.apply,
							value: e.value * detail.multiplier + +detail.plus
						};
					} else {
						let value = 0;
						switch (e.apply) {
							case 'ADULT':
								value = detail.dates.find((x) => x.apply == 'ADULT').value;
								break;
							case 'CHILD':
								value = detail.dates.find((x) => x.apply == 'CHILD').value;
								break;
							case 'BABY':
								value = detail.dates.find((x) => x.apply == 'BABY').value;
								break;
							case 'GUEST':
								value = detail.dates.find((x) => x.apply == 'GUEST').value;
								break;
						}
						return {
							apply: e.apply,
							value: value
						};
					}
				});
				detail.dates = [...arrMap];
			} else { 
				if(!this.radioOta) return
				arrMap = this.popupBatchUpdate.price.priceByOta.find(e => e.roomTypeId === this.radioOta.split("|")[0]).ratePlans.find(pl => pl.ratePlanId === this.radioOta.split("|")[1]).price.dates.map(e => {
					if (!['ADULT', 'CHILD', 'BABY', 'GUEST'].includes(e.apply)) {
						return {
							apply: e.apply,
							value: e.value * detail.multiplier + +detail.plus
						};
					} else {
						let value = 0;
						switch (e.apply) {
							case 'ADULT':
								value = detail.dates.find((x) => x.apply == 'ADULT').value;
								break;
							case 'CHILD':
								value = detail.dates.find((x) => x.apply == 'CHILD').value;
								break;
							case 'BABY':
								value = detail.dates.find((x) => x.apply == 'BABY').value;
								break;
							case 'GUEST':
								value = detail.dates.find((x) => x.apply == 'GUEST').value;
								break;
						}
						return {
							apply: e.apply,
							value: value
						};
					}
				});
				detail.dates = [...arrMap];
			}
		},
		confirmUpdatePrice() {
			this.dialogUpdateRate = false
			let body = [];
			let bodyOverwrite = [];
			let bodyUnOverwrite = [];
			if (this.isOver) return;
			if (!this.checkValidate()) return;
			if (this.popupBatchUpdate.price.updateBy == "bulkUpdate") {
				if (this.popupBatchUpdate.price.selectedRoomType.length === 0 || this.planSelect.length === 0 || this.popupBatchUpdate.price.priceByOtasSelected.length === 0) {
					_alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
					return
				}
				this.popupBatchUpdate.price.hasRoomRate
					.filter((x) => this.popupBatchUpdate.price.selectedRoomType.includes(x.roomTypeId))
					.forEach((y) => {
						y.roomRates.filter(item => this.planSelect.includes(item.ratePlansId)).forEach((z) => {
							z.ota.filter((temp) => this.popupBatchUpdate.price.priceByOtasSelected.includes(temp.ota.id)).forEach((i) => {
								let isValid = false;
								let tempDate = [];
								i.dates.forEach((t) => {
									if (t.value > 0 || t.apply === 'BABY' || t.apply === 'CHILD') {
										tempDate.push({
											apply: t.apply,
											value: t.value,
										});
									}
									if (
										(tempDate.filter((e) => e.apply == "ADULT").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
										(tempDate.filter((e) => e.apply == "CHILD").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
										(tempDate.filter((e) => e.apply == "BABY").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
										(tempDate.filter((e) => e.apply == "GUEST").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0))
									) {
										isValid = true;
									}
								});
								if (isValid) {
									body.push({
										id: i.roomrateId,
										dates: tempDate,
									});
								}
							});
						});
					});
			} else if (this.popupBatchUpdate.price.updateBy == "roomtype") {
				if (this.popupBatchUpdate.price.selectedRoomType.length === 0 || this.planSelect.length === 0) {
					_alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
					return
				}
				this.popupBatchUpdate.price.hasRoomRate
					.filter((x) => this.popupBatchUpdate.price.selectedRoomType.includes(x.roomTypeId))
					.forEach((y) => {
						y.roomRates.filter(item => this.planSelect.includes(item.ratePlansId)).forEach((z) => {
							let isValid = false;
							let tempDate = [];
							z.dates.forEach((t) => {
								if (t.value > 0 || t.apply === 'BABY' || t.apply === 'CHILD') {
									tempDate.push({
										apply: t.apply,
										value: t.value,
									});
								}
								if (
									(tempDate.filter((e) => e.apply == "ADULT").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
									(tempDate.filter((e) => e.apply == "CHILD").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
									(tempDate.filter((e) => e.apply == "BABY").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
									(tempDate.filter((e) => e.apply == "GUEST").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0))
								) {
									isValid = true;
								}
							});
							z.ota.filter((temp) => z.selectedOta.includes(temp.ota.id)).forEach((i) => {
								if (isValid) {
									bodyOverwrite.push({
										id: i.roomrateId,
										dates: tempDate,
									});
									bodyUnOverwrite.push({
										id: i.roomrateId,
										dates: tempDate.map(e => {
											if (e.apply !== "ADULT" && e.apply !== "BABY" && e.apply !== "CHILD" && e.apply !== "GUEST") {
												return e
											} else {

												return i.dates.find(ii => ii.apply == e.apply)
											}
										})
									})
								}
							});
						});
					});
				// if(this.isOverwrite) {
				// 	body = bodyOverwrite
				// } else {
				body = bodyUnOverwrite
				// }
			} else if (this.popupBatchUpdate.price.updateBy == "roomplan") {
				this.popupBatchUpdate.price.priceByRoomPlan
					.filter((x) => this.popupBatchUpdate.price.priceByRoomPlanSelected.includes(x.id))
					.forEach((y) => {
						y.roomTypes.filter((temp) => this.popupBatchUpdate.price.selectedRoomType.includes(temp.id)).forEach((z) => {
							let isValid = false;
							let tempDate = [];
							z.dates.forEach((t) => {

								if (t.value > 0 || t.apply === 'BABY' || t.apply === 'CHILD') {
									tempDate.push({
										apply: t.apply,
										value: t.value,
									});
									if (
										(tempDate.filter((e) => e.apply == "ADULT").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
										(tempDate.filter((e) => e.apply == "CHILD").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
										(tempDate.filter((e) => e.apply == "BABY").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
										(tempDate.filter((e) => e.apply == "GUEST").length > 0 &&
											(tempDate.filter((e) => e.apply == "MON").length > 0 ||
												tempDate.filter((e) => e.apply == "TUE").length > 0 ||
												tempDate.filter((e) => e.apply == "WED").length > 0 ||
												tempDate.filter((e) => e.apply == "THU").length > 0 ||
												tempDate.filter((e) => e.apply == "FRI").length > 0 ||
												tempDate.filter((e) => e.apply == "SAT").length > 0 ||
												tempDate.filter((e) => e.apply == "SUN").length > 0))
									) {
										isValid = true;
									}
								}
							});
							z.roomRates.filter((temp) => z.selectedOta.includes(temp.ota.id)).forEach((i) => {
								if (isValid) {
									body.push({
										id: i.id,
										dates: tempDate,
									});
								}
							});
						});
					});
			} else if (this.popupBatchUpdate.price.updateBy == "ota") {
				this.popupBatchUpdate.price.priceByOta.forEach((x) => {
					x.ratePlans.forEach((y) => {
						let isValid = false;
						let tempDate = [];
						y.price.dates.forEach((z) => {
							if (z.value > 0 || z.apply === 'BABY' || z.apply === 'CHILD') {
								tempDate.push({
									apply: z.apply,
									value: z.value,
								});

								if (
									(tempDate.filter((e) => e.apply == "ADULT").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
									(tempDate.filter((e) => e.apply == "CHILD").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
									(tempDate.filter((e) => e.apply == "BABY").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0)) ||
									(tempDate.filter((e) => e.apply == "GUEST").length > 0 &&
										(tempDate.filter((e) => e.apply == "MON").length > 0 ||
											tempDate.filter((e) => e.apply == "TUE").length > 0 ||
											tempDate.filter((e) => e.apply == "WED").length > 0 ||
											tempDate.filter((e) => e.apply == "THU").length > 0 ||
											tempDate.filter((e) => e.apply == "FRI").length > 0 ||
											tempDate.filter((e) => e.apply == "SAT").length > 0 ||
											tempDate.filter((e) => e.apply == "SUN").length > 0))
								) {
									isValid = true;
								}
							}
						});
						if (isValid) {
							body.push({
								id: y.price.id,
								dates: tempDate,
							});
						}
					});
				});
			}

			if (body.length <= 0) {
				_alert(null, this.$t("PRICE_OR_OTA_IS_REQUIRED"));
			} else {
				this.popupBatchUpdate.isLoading = true;
				body.forEach(item => {
					item.dates.forEach(e => {
						if(e.apply !== 'BABY' && e.apply !== 'ADULT' && e.apply !== 'CHILD' && e.apply !== 'GUEST') {
							e.value = this.formatMoney(+e.value, this.usedCurrency)
						}
					})
				})
				sale_room
					.updatePrice(body)
					.then((res) => {

						if (res.responseCode === 0) {
							this.popupBatchUpdate.isLoading = false;
							_alert(res, this.$t(res.data), false);
						} else {
							_alert(res, this.$t(res.data), false);
						}
					})
					.finally(
						() => {
							this.popupBatchUpdate.isLoading = false;
						}
					);
			}
		},
		changeQuantity(value) {
			let body = {
				id: value.roomrateId,
				maxChildren: +value.dates.find((x) => x.apply == "CHILD").value,
				maxAdults: +value.dates.find((x) => x.apply == 'ADULT').value,
				maxGuest: +value.dates.find((x) => x.apply == 'GUEST').value,
				maxBaby: +value.dates.find((x) => x.apply == 'BABY').value
			};
			service
				.checkQuantity(body)
				.then((res) => {

					var elementA = document.getElementById(value.roomrateId + "-ADULT");
					var elementC = document.getElementById(value.roomrateId + "-CHILD");
					var elementG = document.getElementById(value.roomrateId + "-GUEST");
					var elementB = document.getElementById(value.roomrateId + "-BABY");
					if (res.responseCode === 1) {
						_alert(res, this.$t(res.data), false);
						this.isOver = true;
						switch (res.data) {
							case 'OVER_MAX_ADULTS':
								// elementA.classList.add("border-danger");
								elementA.getElementsByTagName('input')[0].className += " border-danger";
								elementC.getElementsByTagName('input')[0].classList.remove("border-danger");
								elementG.getElementsByTagName('input')[0].classList.remove("border-danger");
								elementB.getElementsByTagName('input')[0].classList.remove("border-danger");
								break;
							case 'OVER_MAX_GUEST':
								elementG.getElementsByTagName('input')[0].getElementsByTagName('input')[0].className += " border-danger";
								elementA.getElementsByTagName('input')[0].getElementsByTagName('input')[0].classList.remove("border-danger");
								elementC.getElementsByTagName('input')[0].getElementsByTagName('input')[0].classList.remove("border-danger");
								elementB.getElementsByTagName('input')[0].getElementsByTagName('input')[0].classList.remove("border-danger");
								break;
							case 'OVER_MAX_CHILDREN':
								elementC.getElementsByTagName('input')[0].getElementsByTagName('input')[0].className += " border-danger";
								elementA.getElementsByTagName('input')[0].getElementsByTagName('input')[0].classList.remove("border-danger");
								elementG.getElementsByTagName('input')[0].getElementsByTagName('input')[0].classList.remove("border-danger");
								elementB.getElementsByTagName('input')[0].getElementsByTagName('input')[0].classList.remove("border-danger");
								break;
							case 'OVER_MAX_BABY':
								elementB.getElementsByTagName('input')[0].className += " border-danger";
								elementA.getElementsByTagName('input')[0].classList.remove("border-danger");
								elementC.getElementsByTagName('input')[0].classList.remove("border-danger");
								elementG.getElementsByTagName('input')[0].classList.remove("border-danger");
								break;
							default:
								break;
						}
					} else {
						this.isOver = false;
						elementA.getElementsByTagName('input')[0].classList.remove("border-danger");
						elementC.getElementsByTagName('input')[0].classList.remove("border-danger");
						elementG.getElementsByTagName('input')[0].classList.remove("border-danger");
						elementB.getElementsByTagName('input')[0].classList.remove("border-danger");
					}
				});
		},
	}
};
</script>